export const siteMapMenu = [
  { name: "Home", link: "/" },
  { name: "Our Medicine", link: "/our-medicines" },
  { name: "Blog", link: "/blog" },
  { name: "Testimonial", link: "/testimonials" },
  { name: "Contact Us", link: "/contact-us" },
  { name: "How To Order", link: "/how-to-order" },
];
